import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';

import ScreensTraditionalCampaignView from './View/ScreensTraditionalCampaignView';
import ScreensTraditionalCampaignForm from './Form/ScreensTraditionalCampaignForm';

function ScreensTraditionalCampaigns() {
  return (
    <Routes>
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensTraditionalCampaignForm}
            requiredPermission="campaigns.create"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            exact
            element={ScreensTraditionalCampaignForm}
            requiredPermission="campaigns.update"
          />
        }
      />
      <Route
        path="/:id"
        element={
          <RoutePrivate
            exact
            element={ScreensTraditionalCampaignView}
            requiredPermission="campaigns.read"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/campaigns/list" />} />
    </Routes>
  );
}

export default ScreensTraditionalCampaigns;
